import { CLOSE_MENU } from 'action-types';

export default function () {
  return {
    type: CLOSE_MENU,
  };
}
